import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

function CatalogHeaderContainer({ blok }) {
  if (!blok) return null;

  return (
    <div
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      {blok.header?.map((nestedBlok) => (
        <StoryblokComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
        />
      ))}

      {blok.body?.map((nestedBlok) => (
        <StoryblokComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
        />
      ))}
    </div>
  );
}

export default CatalogHeaderContainer;
